import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { AlertComponent } from './components/alert/alert.component';
import { BorderedGroupComponent } from './components/bordered-group/bordered-group.component';
import { ButtonComponent } from './components/button/button.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { SwitchCheckboxComponent } from './components/switch-checkbox/switch-checkbox.component';
import { TableCellComponent } from './components/table/table-cell/table-cell.component';
import { TableContentEmptyComponent } from './components/table/table-content-empty/table-content-empty.component';
import { TableContentComponent } from './components/table/table-content/table-content.component';
import { TableHeaderComponent } from './components/table/table-header/table-header.component';
import { TableHeadersComponent } from './components/table/table-headers/table-headers.component';
import { TableRowComponent } from './components/table/table-row/table-row.component';
import { TableComponent } from './components/table/table/table.component';
import { MigrationsAccountsTableComponent } from './components/migrations-accounts-table/migrations-accounts-table.component';

import { NumericInputDirective } from './directives/numeric-input.directive';
import { CreditPipe } from './pipes/credit.pipe';
import { SectionPermissionPipe } from './pipes/section-permission.pipe';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { SearchPipe } from './pipes/search.pipe';
import { ShowMorePipe } from './pipes/show-more.pipe';
import { SearchDropdownComponent } from './components/search-dropdown/search-dropdown.component';
import { ToolPermissonCheckedPipe } from './pipes/tool-permisson-checked.pipe';
import { CheckedPipe } from './pipes/checked.pipe';
import { SubscriptionsPipe } from './pipes/get-subscriptions.pipe';
import { TabsComponent } from './components/tabs/tabs.component';

import { OneApiService } from './services/one-api.service';

const COMPONENTS = [
  AlertComponent,
  BorderedGroupComponent,
  ButtonComponent,
  CreditPipe,
  SectionPermissionPipe,
  ToolPermissonCheckedPipe,
  CheckedPipe,
  LoadingSpinnerComponent,
  MigrationsAccountsTableComponent,
  NumericInputDirective,
  SearchBarComponent,
  SvgIconComponent,
  SwitchCheckboxComponent,
  TableCellComponent,
  TableComponent,
  TableContentComponent,
  TableContentEmptyComponent,
  TableHeaderComponent,
  TableHeadersComponent,
  TableRowComponent,
  ConfirmModalComponent,
  LineChartComponent,
  SearchPipe,
  TabsComponent,
  SearchDropdownComponent,
  ShowMorePipe,
  SubscriptionsPipe,
];

const IMPORTS = [
  CommonModule,
  RouterModule,
  NgbModule,
  FormsModule,
  ReactiveFormsModule,
  AngularSvgIconModule,
];

const SERVICES = [OneApiService];

const DIRECTIVES = [NumericInputDirective];

const EXPORTS = [...DIRECTIVES, ...COMPONENTS];

@NgModule({
  declarations: [COMPONENTS, DIRECTIVES],
  exports: EXPORTS,
  imports: IMPORTS,
  providers: [SERVICES],
})
export class SharedModule {}
